import React, {useEffect, useState} from 'react'
import {useApolloQuery} from 'apollo-hooks'

import productQuery from './Products/getCategoryProductsQuery.main'
import getFilters from './getFilters'
import getWebsiteFiltersQuery from './getWebsiteFiltersQuery'
import ProductFilterContext from './ProductFiltersContext'

export default function ProductFiltersContextProvider({
  categoryId,
  websiteId,
  category,
  children,
  menuId
}) {
  const {data} = useApolloQuery({query: productQuery, variables: {categoryId, menuId}})

  const items = data.category ? data.category.paginatedProducts.items : []

  const {
    data: {filters}
  } = useApolloQuery({query: getWebsiteFiltersQuery, variables: {websiteId}})
  const {categoryFilterTypes, generatedPriceFilters} = getFilters(items, filters)

  const [productFilters, setProductFilters] = useState([])
  const [filterTypes, setFilterTypes] = useState(categoryFilterTypes)
  const [priceFilters, setPriceFilters] = useState(generatedPriceFilters)

  const getAllFilters = () => {
    return getFilters(items, filters)
  }
  useEffect(() => {
    setFilterTypes(categoryFilterTypes)
    setProductFilters([])
    setPriceFilters(generatedPriceFilters)
  }, [categoryId])

  return (
    <ProductFilterContext.Provider
      value={{
        productFilters: productFilters,
        setProductFilters: setProductFilters,
        filterTypes: filterTypes,
        setFilterTypes: setFilterTypes,
        priceFilters: priceFilters,
        setPriceFilters: setPriceFilters,
        getAllFilters: getAllFilters
      }}>
      {children}
    </ProductFilterContext.Provider>
  )
}
